export default __webpack_public_path__ + "static/media/thrivingpets-logo-footer.a93cc3bc.svg";